export enum EDeviceScreenWidth {
  _null = -1,
  Tiny = 0,
  Small = 1,
  Medium = 2,
  Large = 3,
  ExtraLarge  = 4
}

// export enum EDeviceOrientation{
//   _null = -1,
//   Portrait = 0,
//   Landscape = 1
// }

export enum EDesktopOS {
  Linux = 'linux',
  MacOS = 'mac_os',
  Unix = 'unix',
  Unknown = 'unknown',
  Windows = 'windows'
}

export enum EMobileOS {
  Android = 'android',
  iOS = 'ios',
  Unknown = 'unknown',
  WindowsPhone = 'Windows Phone'
}

export enum EBrowser {
  Unknown = "Unknown",
  GoogleChrome = "Chrome",
  Firefox = "Firefox",
  Safari= "Safari",
  Brave= "Brave",
  Edge= "Edge",
  Opera= "Opera",
  MSIE= "MSIE",
  InternetExplorer  = "InternetExplorer"
} 